'use client';

import { useEffect } from 'react';
import { SnackBar } from '@pixum/snackbar';
import { Icon } from '@pixum/icon';
import { useCartErrorStore } from 'stores/cart';

const AUTO_CLEAR_MS = 4000;

export function CartMutationErrorSnackbar() {
  const { error, setError } = useCartErrorStore();

  useEffect(() => {
    if (!error) return;

    const timer = setTimeout(() => setError(null), AUTO_CLEAR_MS);

    return () => clearTimeout(timer);
  }, [error, setError]);

  if (!error) return null;

  return (
    <SnackBar
      icon={<Icon name="warningsignal" ariaHidden />}
      message={error}
      linkText=""
      theme={{ base: 'ink', accent: 'brand', brightness: 'dark' }}
      onClick={() => setError(null)}
    />
  );
}
